import React from 'react';
import { cn } from '@/shared/utils/utils';

interface FeedbackIllustrationProps {
  className?: string;
}

/**
 * Feedback illustration for feedback-specific interactions and forms
 */
export const FeedbackIllustration: React.FC<FeedbackIllustrationProps> = ({
  className,
}) => {
  return (
    <img
      src="/undraw-illustrations/undraw_feedback_ebmx.svg"
      alt="Feedback illustration"
      className={cn('object-contain w-1/4 2xl:w-1/2', className)}
    />
  );
};
